interface IComponentLink {
	component: string;
	link: string;
}

export default class ComponentLink {
	public readonly component: string;
	public readonly link: string;
	public constructor({ component, link }: IComponentLink) {
		this.component = component;
		this.link = link;
	}
}
